const brand = "BINAPSIS";
const baseUrl = "http://localhost:3000";
const baseUrlApi = "http://localhost:3000/api";

export const config = {
  brand,
  baseUrl,
  baseUrlApi,
  defaultUserImage:
    "https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg",
  imgbbApiKey: "f369e564a35464c187abaecc81d252ab",
  email: "info@binapsis-software.com",
  phone: "+54 9 11 5573 9583",
  address: "Palermo, Buenos Aires, Argentina",
  socialMedia: {
    facebook: "https://www.facebook.com/share/1Gzu8htWnS/?mibextid=wwXIfr",
    twitter: "",
    instagram: "https://www.instagram.com/binapsis.software?igsh=MTVtMTFubWdkdnlxMQ==",
    linkedin: "",
  },
  theme: {
    logo: "/logo-binapsis.png",
    animatedLoaderLogo: "/logo-binapsis-loader.png",
    size: "big",
    brandLogo: "logo-binapsis.png",
    colors: {
      primaryColor: "#2BA8DB",
      secondaryColor: "#40B795",
      tertiaryColor: "#F5A623",
      quaternaryColor: "#9013FE",
      textMenuColor: "#FFFFFF",
      textMenuHoverColor: "#FFFFFF",
    },
  },
  whatsappNumber: "+5491155739583",
  mercadopago: {
    clientId: "3157641258775050",
    redirectUrl: baseUrl + "/mercadopago/callback",
  },
  subscription: {
    price: 9.90,
    billingCycle: "monthly",
    conversionRate: 1500,
  },
};
